<div class="wrapper">
  <app-loader *ngIf="isButtonLoader" isAlertDialog="true"></app-loader>

  <div class="section_wrapper" [ngStyle]="{marginTop: isLoggedIn?'24px':'96px'}">
    <h1 class="title font_40_a32" *ngIf="!myHomeId">{{ isEdit ? 'Edit your property address' : 'Your property has been
      located!' }}
    </h1>
    <!-- if the [isEdit] variable is true then showing editing option -->
    <div *ngIf="isEdit==true" class="edit_Form">
      <form class="example-form input">
        <div class="street_unit">
          <mat-form-field class="example-full-width genericTextFiled ">
            <mat-label>street adrress</mat-label>
            <input matInput placeholder="" name="streetAddress" [(ngModel)]="streetAddress">
          </mat-form-field>
          <mat-form-field class="example-full-width genericTextFiled">
            <mat-label>Unit number</mat-label>
            <input matInput placeholder="" name="unitNumber" [(ngModel)]="unitNumber">
          </mat-form-field>
        </div>
        <div class="city_state_zip">
          <mat-form-field class="example-full-width genericTextFiled">
            <mat-label>City</mat-label>
            <input type="text" matInput placeholder="" name="city" [(ngModel)]="city">
          </mat-form-field>
          <mat-form-field appearance="fill" class="state example-full-width genericTextFiled">
            <mat-label>State</mat-label>
            <!-- <img matSuffix src="../../../assets/icons/down_arrow_black.svg" alt=""> -->
            <mat-select [(ngModel)]="state" name="state">
              <mat-option *ngFor="let state of stateList" [value]="state.value">
                {{state.viewValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="example-full-width genericTextFiled">
            <mat-label>Zip code</mat-label>
            <input matInput placeholder="" name="zipCode" [(ngModel)]="zipCode">
          </mat-form-field>
        </div>
        <div class="update_btn_box">
          <app-green-button-v2 (click)="toggleButton()" label="Update address" [width]="'218px'" [height]="'60px'">
            <img class="after" src="../../../assets/icons/arrow_white.svg" alt="arrow_white" style="margin-left: 10px;">
          </app-green-button-v2>
        </div>
      </form>
    </div>

    <form *ngIf="isEdit==false" class=" address_form input ">
      <mat-form-field class="example-full-width searchTextField">
        <mat-label>Address</mat-label>
        <input matInput placeholder="" name="address" [(ngModel)]="address">
        <button matSuffix class="edit_button">
          <div (click)="toggleButton()" class="edit_icon"></div>
          <!-- <img (click)="toggleButton()" src="../../../assets/icons/search_edit.svg" alt="edit_icon"> -->
        </button>
      </mat-form-field>
    </form>

    <!-- images and map -->
    <div class="land_image_and_map">
      <img class="carousel_item" *ngIf="imgUrl!=null" src={{imgUrl}}>
      <img class="carousel_item" *ngIf="imgUrl==null" src="../../../assets/images/no_image_availble.png">

      <google-map class="carousel_item" [zoom]="mapZoom" [center]="mapCenter" [options]="mapOptions">
        <map-marker #marker="mapMarker" [position]="mapCenter" [options]="markerOptions"
          (mapClick)="openInfoWindow(marker)">
        </map-marker>
        <map-info-window>{{ markerInfoContent }}</map-info-window>
      </google-map>
    </div>


    <!-- slider -->
    <div class="slider_box">
      <div *ngIf="!myHomeId">
        <ngx-slider [(value)]="sliderValue" [options]="options" (userChange)="onUserChange($event)"></ngx-slider>
        <p class=" drag_text">Drag the Slider to Adjust Your Home Value.</p>
        <p class="font_20_a32_500">This is the savings you can expect by using {{ companyName }}</p>
        <p class="money">${{ minSavings | number }} to ${{ maxSavings | number }}</p>
      </div>

      <app-green-button-v2 [width]="'211px'" [height]="'60px'" label="Start Listing" (click)="startListing()">
        <img class="after" src="../../../assets/icons/arrow_white.svg" alt="arrow_white" style="margin-left: 10px;">
      </app-green-button-v2>

    </div>
  </div>
</div>